var $c1ce9d969bfa6909$exports = {};
"use strict";
/////////////////////////////////////////////////////////////////////////
// UTILITY CLASSES
// Resize fires continuously while a window is dragged; coalesce the work into
// one callback per animation frame instead of one per event
function $c1ce9d969bfa6909$var$perFrame(fn) {
    let queued = false;
    return function() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(()=>{
            queued = false;
            fn();
        });
    };
}
/////////////////////////////////////////////////////////////////////////
// HEADER SECTION
const $c1ce9d969bfa6909$var$LONG_DEV_INTRO = "Hello! I am Joshmar \uD83D\uDC4B\uD83C\uDFFB";
const $c1ce9d969bfa6909$var$SHORT_DEV_INTRO = "Hi! I'm Josh \uD83D\uDC4B\uD83C\uDFFB";
const $c1ce9d969bfa6909$var$headerIntro = document.querySelector(".header__introductionbox")?.firstElementChild;
function $c1ce9d969bfa6909$var$updateSize() {
    if (!$c1ce9d969bfa6909$var$headerIntro) return;
    if (Number(window.innerWidth) <= 1200) $c1ce9d969bfa6909$var$headerIntro.textContent = $c1ce9d969bfa6909$var$SHORT_DEV_INTRO;
    else $c1ce9d969bfa6909$var$headerIntro.textContent = $c1ce9d969bfa6909$var$LONG_DEV_INTRO;
}
window.addEventListener("resize", $c1ce9d969bfa6909$var$perFrame($c1ce9d969bfa6909$var$updateSize));
$c1ce9d969bfa6909$var$updateSize(); // Set the correct intro on load, not just on resize
/////////////////////////////////////////////////////////////////////////
// EXPERIENCE SECTION
const $c1ce9d969bfa6909$var$EXP_MAP = new Map([
    [
        "work",
        "work"
    ],
    [
        "technical",
        "tech"
    ],
    [
        "education",
        "edu"
    ],
    [
        "languages",
        "lang"
    ]
]);
const $c1ce9d969bfa6909$var$allDescription = document.querySelectorAll(".experience__description");
const $c1ce9d969bfa6909$var$expTitles = document.querySelectorAll(".experience__title");
function $c1ce9d969bfa6909$var$removeAllTitleSelection() {
    $c1ce9d969bfa6909$var$expTitles.forEach((title)=>title.classList.remove("experience__title--active"));
}
function $c1ce9d969bfa6909$var$hideAllDescription() {
    $c1ce9d969bfa6909$var$allDescription.forEach((descrption)=>{
        descrption.classList.add("u-hidden");
    });
}
function $c1ce9d969bfa6909$var$activateTab(title) {
    const selection = title.firstElementChild.textContent.trim().toLowerCase();
    const currentDescription = document.querySelector(`.experience__description-${$c1ce9d969bfa6909$var$EXP_MAP.get(selection)}`);
    // Resolve the panel before hiding anything, so an unknown label can never
    // leave the section with every panel hidden
    if (!currentDescription) return;
    $c1ce9d969bfa6909$var$removeAllTitleSelection();
    title.classList.add("experience__title--active");
    // Roving tabindex: only the selected tab stays in the page tab order
    $c1ce9d969bfa6909$var$expTitles.forEach((tab)=>{
        const isActive = tab === title;
        tab.setAttribute("aria-selected", isActive);
        tab.tabIndex = isActive ? 0 : -1;
    });
    $c1ce9d969bfa6909$var$hideAllDescription();
    currentDescription.classList.remove("u-hidden");
}
$c1ce9d969bfa6909$var$expTitles.forEach(function(title) {
    title.addEventListener("click", function(e) {
        e.preventDefault();
        $c1ce9d969bfa6909$var$activateTab(title);
    });
});
// Arrow keys move between tabs, as a role="tablist" leads users to expect
const $c1ce9d969bfa6909$var$ARROW_STEP = new Map([
    [
        "ArrowRight",
        1
    ],
    [
        "ArrowDown",
        1
    ],
    [
        "ArrowLeft",
        -1
    ],
    [
        "ArrowUp",
        -1
    ]
]);
document.querySelector(".experience__titlebox")?.addEventListener("keydown", function(e) {
    const step = $c1ce9d969bfa6909$var$ARROW_STEP.get(e.key);
    if (!step) return;
    const tabs = [
        ...$c1ce9d969bfa6909$var$expTitles
    ];
    const current = tabs.indexOf(document.activeElement);
    if (current === -1) return;
    e.preventDefault();
    const next = tabs[(current + step + tabs.length) % tabs.length];
    next.focus();
    $c1ce9d969bfa6909$var$activateTab(next);
});
/////////////////////////////////////////////////////////////////////////
// NAVBAR SECTION
const $c1ce9d969bfa6909$var$hamburger = document.querySelector(".hamburger");
const $c1ce9d969bfa6909$var$navMenu = document.querySelector(".navMenu");
const $c1ce9d969bfa6909$var$NAV_BREAKPOINT = 760; // Matches the media query in _navbar.scss
function $c1ce9d969bfa6909$var$closeMenu() {
    $c1ce9d969bfa6909$var$hamburger?.classList.remove("active");
    $c1ce9d969bfa6909$var$navMenu?.classList.remove("active");
    $c1ce9d969bfa6909$var$hamburger?.setAttribute("aria-expanded", "false");
}
$c1ce9d969bfa6909$var$hamburger?.addEventListener("click", ()=>{
    const isOpen = Boolean($c1ce9d969bfa6909$var$navMenu?.classList.toggle("active"));
    $c1ce9d969bfa6909$var$hamburger.classList.toggle("active", isOpen);
    $c1ce9d969bfa6909$var$hamburger.setAttribute("aria-expanded", isOpen);
});
// Close the menu once a destination is picked, and when the viewport grows
// past the breakpoint where the menu stops applying
$c1ce9d969bfa6909$var$navMenu?.querySelectorAll("a").forEach((link)=>{
    link.addEventListener("click", $c1ce9d969bfa6909$var$closeMenu);
});
window.addEventListener("resize", $c1ce9d969bfa6909$var$perFrame(()=>{
    if (window.innerWidth > $c1ce9d969bfa6909$var$NAV_BREAKPOINT) $c1ce9d969bfa6909$var$closeMenu();
}));
/////////////////////////////////////////////////////////////////////////
// LOTTIE ANIMATIONS
// Both the player script and the animation JSON come from third-party hosts.
// If either is unreachable the element renders nothing at all, so show a
// placeholder while it loads and collapse it if it never arrives.
const $c1ce9d969bfa6909$var$LOTTIE_TIMEOUT_MS = 8000;
document.querySelectorAll("dotlottie-player").forEach((player)=>{
    // Collapse the wrapper only when the player is its only child; the header
    // shares its box with the coding illustration, which must stay visible
    const box = player.parentElement;
    const target = box && box.children.length === 1 ? box : player;
    target.classList.add("lottie--loading");
    let settled = false;
    const settle = (failed)=>{
        if (settled) return;
        settled = true;
        target.classList.remove("lottie--loading");
        if (failed) target.classList.add("lottie--failed");
    };
    player.addEventListener("ready", ()=>settle(false));
    player.addEventListener("load", ()=>settle(false));
    player.addEventListener("error", ()=>settle(true));
    // The CDN script itself may never arrive, in which case no event ever fires
    setTimeout(()=>settle(true), $c1ce9d969bfa6909$var$LOTTIE_TIMEOUT_MS);
});
/////////////////////////////////////////////////////////////////////////
// FOOTER SECTION
const $c1ce9d969bfa6909$var$footerDate = document.querySelector(".footer-date");
const $c1ce9d969bfa6909$var$date = new Date();
if ($c1ce9d969bfa6909$var$footerDate) $c1ce9d969bfa6909$var$footerDate.textContent = `\xa9 ${$c1ce9d969bfa6909$var$date.getFullYear()}`;
/////////////////////////////////////////////////////////////////////////
// REDUCED MOTION
// CSS covers the keyframes and transitions, but the Lottie players animate
// internally, so they have to be stopped through their own element API
if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    const players = document.querySelectorAll("dotlottie-player");
    // Stops any player that has not been upgraded by the CDN script yet
    players.forEach((player)=>player.removeAttribute("autoplay"));
    customElements.whenDefined("dotlottie-player").then(()=>{
        players.forEach((player)=>player.pause?.());
    });
    // The project demos are autoplaying video; leave them on their poster frame
    document.querySelectorAll("video[autoplay]").forEach((video)=>{
        video.removeAttribute("autoplay");
        video.pause();
    });
}


//# sourceMappingURL=index.77af9926.js.map
